import { render, staticRenderFns } from "./AdminInstanciasComponent.vue?vue&type=template&id=773f2f68&"
import script from "./AdminInstanciasComponent.vue?vue&type=script&lang=js&"
export * from "./AdminInstanciasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports